import {  get } from "../../service/api";

const GetMerchantSettle = async (merchantId,queryString) => {
    try {
        const response = await get(`/merchant/${merchantId}/merchantSettle?1=1${queryString}`);
        return response;
    } catch (error) {
        console.error('Error GetMerchantSettle:', error);
        throw error;
    }
};

export default GetMerchantSettle;